import ClientForm from "../../components/clients/ClientForm"
import { FaArrowLeft } from "react-icons/fa6";

const clientRegister = ({ onBack }) => {

    return (

        <div>
            {/* Bouton Retour */}
            <button
            onClick={onBack}
            className=" flex items-center gap-2 text-white/80 hover:text-white font-semibold transition-colors group">
                <div className="p-2 bg-white/10 rounded-full group-hover:bg-white/20 transition-all">
                    <FaArrowLeft />
                </div>
                Retour au suivi
            </button>
            <h1 className="font-bold text-white text-4xl mt-4 mb-6">Inscription Expéditeur</h1>
            <ClientForm />
        </div>

    )

}

export default clientRegister